export const FETCH_WISHLIST = 'FETCH_WISHLIST';
export const FETCH_WISHLIST_SUCCESS = `${FETCH_WISHLIST}_SUCCESS`;
export const FETCH_WISHLIST_FAIL = `${FETCH_WISHLIST}_FAIL`;

const initialState = { isLoading: false, products: [] };

/* eslint-disable */
const WishlistReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_WISHLIST:
      return { ...state, isLoading: true };
    case FETCH_WISHLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        products: action.payload.data,
      };
    case FETCH_WISHLIST_FAIL:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export default WishlistReducer;
